import './types.js';
import { profileStore } from "../../stores/profile.js";
/**
 * @type {Menu}
 * */
export const menu = [
    {
        label: 'Войти',
        route: {
            to: '/sign-in'
        },
        condition: () => !profileStore.isLoggedIn,
    },
    {
        label: 'Зарегистрироваться',
        route: {
            to: '/sign-up'
        },
        condition: () => !profileStore.isLoggedIn,
    },
    {
        label: 'Добавить трек',
        route: {
            to: '/add-track'
        },
        condition: () => profileStore.isLoggedIn,
    },
    {
        label: 'Поиск',
        route: {
            to: '/search'
        },
        condition: () => profileStore.isLoggedIn,
    },
    {
        label: 'Мои плейлисты',
        route: {
            to: '/my-playlists'
        },
        condition: () => profileStore.isLoggedIn,
    },
    {
        label: 'Выйти',
        route: {
            to: '/sign-out'
        },
        condition: () => profileStore.isLoggedIn,
    }
];
